import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ErrorBoundary } from 'react-error-boundary';

import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/features/auth/components/auth-provider';

import { queryClient } from '../utils/query-client';

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div role="alert" className="p-4">
      <h2 className="text-lg font-semibold text-red-600">
        Something went wrong:
      </h2>
      <pre className="mt-2 text-sm text-red-500">{error.message}</pre>
    </div>
  );
}

interface AppProviderProps {
  children: React.ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <AuthProvider>{children}</AuthProvider>
      </QueryClientProvider>
      <Toaster />
    </ErrorBoundary>
  );
}
